import { UserAttributes } from '../models/login-register-model';
import { HostPlanAttributes } from '../models/host-plan-model';
import { PartnerPlanAttributes } from '../models/partner-plan-model';
import { DriverPlanAttributes } from '../models/driver-plan-model';
import { UserPlanAssociation } from '../models/user-plan-associations-model';
import {
  ApiRequest,
  ApiResponse,
  fetchDataFromAPITyped,
  isSuccessful,
} from './api-requests';
import { notificationService } from './notification-service';

export const getHostPlans = async () => {
  try {
    const apiRequest: ApiRequest = {
      route: `plans/getHostPlans`,
      request: {
        method: 'GET',
        entity: 'userPlan',
        body: undefined,
      },
    };
    const hostPlans = await fetchDataFromAPITyped<HostPlanAttributes[]>(apiRequest);
    if (isSuccessful(hostPlans.status)) {
      return hostPlans.payload;
    }
    return false;
  } catch (error) {
    notificationService.sendNotification('error', 'Unable to get host plans');
    return false;
  }
};

export const getPartnerPlans = async () => {
  try {
    const apiRequest: ApiRequest = {
      route: `plans/getPartnerPlans`,
      request: {
        method: 'GET',
        entity: 'userPlan',
        body: undefined,
      },
    };
    const partnerPlans = await fetchDataFromAPITyped<PartnerPlanAttributes[]>(apiRequest);
    if (isSuccessful(partnerPlans.status)) {
      return partnerPlans.payload;
    }
    return false;
  } catch (error) {
    notificationService.sendNotification('error', 'Unable to get partner plans');
    return false;
  }
}

export const getDriverPlans = async () => {
  try {
    const apiRequest: ApiRequest = {
      route: `plans/getDriverPlans`,
      request: {
        method: 'GET',
        entity: 'userPlan',
        body: undefined,
      },
    };
    const driverPlans = await fetchDataFromAPITyped<DriverPlanAttributes[]>(apiRequest);
    if (isSuccessful(driverPlans.status)) {
      return driverPlans.payload;
    }
    return false;
  } catch (error) {
    notificationService.sendNotification('error', 'Unable to get driver plans');
    return false;
  }
}